
const BASE_URL = "https://api.iassets.in/";
// const BASE_URL = "http://localhost:5100/";
// 
// const BASE_URL_PROD = "https://prod-api.example.com/";


export const endPoints = {
    LOGIN: BASE_URL + "api/auth/loginAdmin",
    GET_USER_LIST: BASE_URL + "api/users",
    GET_USER_BY_ID: BASE_URL + "api/users",
    UPDATE_USER: BASE_URL + "api/users",
    DALETE_USER: BASE_URL + "api/users",
    CREATE_USER: BASE_URL + "api/users",
    VERIFY_TOKEN: BASE_URL + "api/auth/verifyToken",
    GET_CITY_BY_STATE: BASE_URL + "api/areas/by-city",
    GET_AREA_LIST: BASE_URL + "api/areas",
    CREATE_AREA: BASE_URL + "api/areas",
    PROPERTY_TYPE: BASE_URL + "api/propertyTypes",
    APPROVE_VALUER: BASE_URL + "approveValuer",
    PROPERTIES_FOR_SALE: BASE_URL + "api/propertyForSale",
    GET_ALL_PROPERTIES: BASE_URL + "api/allProperties",
    GET_STREET_LIST: BASE_URL + "api/street",
    GET_STREET_BY_AREA: BASE_URL + "api/street/by-area",
    GET_LOCATION_LIST: BASE_URL + "api/areas",
    CREATE_LOCATION: BASE_URL + "api/areas",
    GET_AGENT_SEARCHES: BASE_URL + "api/allProperties/agent-searches",
    DELETE_AGENT_SEARCH: BASE_URL + "api/allProperties/agent-searches",
    GET_AREA_LIST_BY_CITY: BASE_URL + "api/areas/by-city",
    GET_CONSTRUCTION_MASTER: BASE_URL + "api/construction-master",
    UPDATE_CONSTRUCTION_MASTER: BASE_URL + "/construction-master/update",
    GET_ADMIN_MANAGE_PROPERTY_LIST: BASE_URL + "api/manage-property/admin/list",
    DELETE_MANAGE_PROPERTY: BASE_URL + "api/manage-property/delete-multiple",
    GET_AGENT_INTERACTIONS: BASE_URL + "api/agents/interactions",
    GET_ALL_REQUESTS: BASE_URL + "api/requests",
    GET_LOCATION_VALUERS: BASE_URL + "api/requests/valuers",
    ASSIGN_VALUER: (id: string) => BASE_URL + `api/requests/${id}/assign`,
    GET_ALL_CONSTRUCTION_SERVICES: BASE_URL + "api/construction-service",
    CREATE_CONSTRUCTION_SERVICE: BASE_URL + "api/construction-service",
    UPDATE_CONSTRUCTION_SERVICE: (id: string) => BASE_URL + `api/construction-service/${id}`,
    DELETE_CONSTRUCTION_SERVICE: (id: string) => BASE_URL + `api/construction-service/${id}`,
    SEND_NOTIFICATION: BASE_URL + `api/notifications/send`,
    DASHBOARD_STATS: BASE_URL + `api/admin/dashboard-stats`,
    GET_NOTIFICATIONS:BASE_URL + 'api/notifications/all',
    DELETE_USER :BASE_URL + "api/users"
}

const MAP_KEY = "AIzaSyDEjurf8SzLutES4Dw7Y0FQvrIy-gvvS-U"
